export const GET_CMS_PAGE_LIST_FAIL = "GET_CMS_PAGE_LIST_FAIL";
export const GET_CMS_PAGE_LIST_REQUEST = "GET_CMS_PAGE_LIST_REQUEST";
export const GET_CMS_PAGE_LIST_SUCCESS = "GET_CMS_PAGE_LIST_SUCCESS";

export const GET_CMS_PAGE_DETAIL_FAIL = "GET_CMS_PAGE_DETAIL_FAIL";
export const GET_CMS_PAGE_DETAIL_REQUEST = "GET_CMS_PAGE_DETAIL_REQUEST";
export const GET_CMS_PAGE_DETAIL_SUCCESS = "GET_CMS_PAGE_DETAIL_SUCCESS";

export const POST_CMS_PAGE_CREATE_FAIL = "POST_CMS_PAGE_CREATE_FAIL";
export const POST_CMS_PAGE_CREATE_REQUEST = "POST_CMS_PAGE_CREATE_REQUEST";
export const POST_CMS_PAGE_CREATE_SUCCESS = "POST_CMS_PAGE_CREATE_SUCCESS";
